import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/outcome',
    name: 'outcome',

    component: () => import('../views/outcome.vue')
  },
  {
    path: '/querySearch',
    name: 'QuerySearch',

    component: () => import('../views/querySearch/index.vue')
  },
  {
    path: '/queryDetail',
    name: 'QueryDetail',

    component: () => import('../views/detail/index.vue')
  },
  {
    path: '/similar',
    name: 'Similar',

    component: () => import('../views/similar/index.vue')
  },
  {
    path: '/basketQuestions',
    name: 'BasketQuestions',

    component: () => import('../views/basketQuestions/index.vue')
  },
  {
    path: '/kindSearch',
    name: 'KindSearch',

    component: () => import('../views/kindSearch/index.vue')
  },
  {
    path: '/knowEnglish',
    name: 'KnowEnglish',

    component: () => import('../views/knowEnglish/index.vue')
  },
  {
    path: '/correctingWriting',
    name: 'CorrectingWriting',

    component: () => import('../views/correctingWriting/index.vue')
  },
  {
    path: '/detailWriting',
    name: 'DetailWriting',

    component: () => import('../views/correctingWriting/components/outcomeSearch.vue')
  },
  {
    path: '/compute',
    name: 'Compute',

    component: () => import('../views/compute/index.vue')
  },
  {
    path: '/detailSearch',
    name: 'DetailSearch',

    component: () => import('../views/querySearch/components/outcomeSearch.vue')
  },
  {
    path: '/detailDialog',
    name: 'DetailDialog',

    component: () => import('../views/knowEnglish/components/dialogueDetail.vue')
  },
  {
    path: '/centerPersonal',
    name: 'CenterPersonal',

    component: () => import('../views/centerPersonal/index.vue')
  },
  {
    path: '/paper',
    name: 'Paper',

    component: () => import('../views/paper/index.vue')
  },
  {
    path: '/paperDetail',
    name: 'PaperDetail',

    component: () => import('../views/paper/components/detail.vue')
  },
  {
    path: '/chatMedia',
    name: 'ChatMedia',

    component: () => import('../views/chatMedia/index.vue')
  },
  {
    path: '/chatMediaDetail',
    name: 'ChatMediaDetail',

    component: () => import('../views/chatMedia/components/detail.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router